<template>
  <button
    class="product-card"
    :class="{ 'product-card--out': isOutOfStock(product) }"
    @click="addToCart(product)"
    :disabled="isOutOfStock(product)"
  >
    <h6 class="mb-1">{{ product.name }}</h6>
    <p class="text-muted small mb-1">{{ product.sku }}</p>
    <p class="price mb-1">{{ formatMoney(product.unitPrice) }}</p>
    <p class="stock small mb-0" :class="stockClass(product)">
      {{ stockLabel(product) }}
    </p>
  </button>
</template>
<script>
export default {
  name: "ProductCard",
  props: {
    product: {
      type: Object,
      required: true,
    },
    addToCart: {
      type: Function,
      required: true,
    },
  },
  methods: {
    stockLabel(product) {
      const available = product.stock?.available ?? 0;
      return available > 0 ? `${available} in stock` : "Out of stock";
    },
    stockClass(product) {
      const available = product.stock?.available ?? 0;
      if (available <= 0) return "text-danger";
      if (available <= 5) return "text-warning";
      return "text-muted";
    },
    isOutOfStock(product) {
      return (product.stock?.available ?? 0) <= 0;
    },
  },
};
</script>
